import { createSlice } from '@reduxjs/toolkit';

import {
  serviceGetCompany,
  servicePostCompany,
  servicePutCompany,
  serviceDeleteCompany,
} from 'utils';


const initialState = {
  data: null,
  isLoaded: {
    post: false,
    put: false,
    delete: false,
    get: false,
  },
  success: {
    post: false,
    put: false,
    delete: false,
    get: false,
  },
  error: {
    post: false,
    put: false,
    delete: false,
    get: false,
  },
}

const CompanySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    dataRequest(state, action) {
      return { ...state, isLoaded: { ...state.isLoaded, [action.payload]: true } };
    },

    dataSuccess(state, action) {
      return {
        ...state,
        isLoaded: { ...state.isLoaded, [action.payload.fetchType]: false },
        success: { ...state.success, [action.payload.fetchType]: true },
        data: action.payload.data || null,
      };
    },

    dataFailure(state, action) {
      return {
        ...state,
        isLoaded: { ...state.isLoaded, [action.payload.fetchType]: false },
        error: { ...state.error, [action.payload.fetchType]: action.payload.data?.message },
      };
    },

    cleanUpCompany() {
      return initialState;
    },

    cleanUpMessageCompany(state) {
      return {
        ...state,
        isLoaded: initialState.isLoaded,
        success: initialState.success,
        error: initialState.error,
      };
    },

  }
});

const {
  dataRequest,
  dataSuccess,
  dataFailure,
  cleanUpCompany,
  cleanUpMessageCompany,
} = CompanySlice.actions;

const fetchPostCompany = (body) => {
  return (dispatch) => {
    dispatch(dataRequest('post'));
    servicePostCompany(body)
      .then((response) => dispatch(dataSuccess({data: response.data, fetchType: 'post'})))
      .catch((err) => dispatch(dataFailure({data: err, fetchType: 'post'})));
  };
};

const fetchGetCompany = ({ query }) => {
  return (dispatch) => {
    dispatch(dataRequest('get'));
    serviceGetCompany()
      .then((response) => {
        const companyData = response.data.find(c => c.company_id === Number(query.companyId));
        return dispatch(dataSuccess({data: companyData, fetchType: 'get'}))
      })
      .catch((err) => dispatch(dataFailure({data: err, fetchType: 'get'})));
  };
};

const fetchPutCompany = (body) => {
  return (dispatch) => {
    dispatch(dataRequest('put'));
    servicePutCompany(body)
      .then((response) => dispatch(dataSuccess({data: response.data, fetchType: 'put'})))
      .catch((err) => dispatch(dataFailure({data: err, fetchType: 'put'})));
  };
};

const fetchDeleteCompany = (body) => {
  return (dispatch) => {
    dispatch(dataRequest('delete'));
    serviceDeleteCompany(body)
      .then((response) => dispatch(dataSuccess({data: response.data, fetchType: 'delete'})))
      .catch((err) => dispatch(dataFailure({data: err, fetchType: 'delete'})));
  };
};

export {
  fetchGetCompany,
  fetchPostCompany,
  fetchPutCompany,
  fetchDeleteCompany,
  cleanUpCompany,
  cleanUpMessageCompany,
};

export default CompanySlice.reducer;
